const theme = {}

theme.palette = {
    primary: ['#e7bc38'],
    border: ['rgb(240, 240, 240)'],
    text: ['rgba(0, 0, 0, 0.85)'],
}

export default theme
